import { Injectable, inject } from '@angular/core';
import { app } from '@df/core/app';
import { DfEventService } from '@df/core/service/df-event';
import { Ab } from '@df/module-ab/ab.namespace';
import { IShortcutChildItem, IShortcutItem } from '@icms/plugin/shortcuts/icms-shortcuts.provider';

@Injectable({
    providedIn: 'root'
})
export class AbCms2ShortcutsProvider {
    private dfEventService = inject(DfEventService);

    appInitialize() {
        this.dfEventService.before(event => {
            if (event.id === 'iCmsProvide' && event.data.providerId === 'shortcuts') {
                this.injectActions(event.data.value as IShortcutItem[]);
            }
        });
    }

    private injectActions(items: IShortcutItem[]) {
        items.push({
            title: 'AB testing',
            children: [
                {
                    command: `Set variant`,
                    info: `list experiments and change currently previewed variants`,
                    action: () => this.listExperiments()
                }
            ]
        });
    }

    private listExperiments() {
        const experiments = app.ab.status();
        if (!experiments.length) {
            alert('No experiments found');
        } else {
            if (experiments.length) {
                return [
                    {
                        title: 'Choose experiment',
                        children: experiments.map(experiment => {
                            const expCommand: Omit<IShortcutChildItem, 'action'> = {
                                command: experiment.name,
                                info: this.getExpInfo(experiment)
                            };

                            (expCommand as IShortcutChildItem).action = () => [
                                {
                                    title: 'Choose variant',
                                    children: experiment.variants.map(variant => ({
                                        command: variant,
                                        action: () => {
                                            app.ab.setVariant(experiment.name, variant);
                                            expCommand.info = this.getExpInfo(experiment, true);
                                            alert(`Variant ${variant} set for experiment "${experiment.name}"`);
                                            return 'back';
                                        }
                                    }))
                                }
                            ];
                            return expCommand as IShortcutChildItem;
                        })
                    }
                ];
            }
        }
    }

    private getExpInfo(experiment: Ab.IExperimentStatusInfo, fresh = false) {
        return `variant ${(fresh ? app.ab.getVariant(experiment.name) : experiment.variant) || 'A'},  ${experiment.key || 'no key'} (${experiment.active ? 'active' : 'inactive'})`;
    }
}
